<template>
  <div class="app-skeleton" aria-hidden="true" />
</template>

<style scoped>
.app-skeleton {
  display: block;
  position: relative;
  overflow: hidden;
  background: #e6ebf1;
}

.app-skeleton::after {
  position: absolute;
  inset: 0;
  content: "";
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.62) 45%,
    transparent 100%
  );
  animation: app-skeleton-shimmer 1.15s ease-in-out infinite;
}

@keyframes app-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
